var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileSwich(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 314,
    viewBox: "0 0 224 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.12697,
    height: 10.2678,
    transform: "translate(-9.01001 125.496)",
    fill: "#10211A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0796,
    y: 145.001,
    width: 9.13871,
    height: 51.786,
    rx: 2,
    fill: "#10211A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1257,
    y: 129.77,
    width: 1.21849,
    height: 80.4206,
    rx: 0.609247,
    fill: "#10211A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150.891,
    y: 66.4079,
    width: 9.13871,
    height: 58.4877,
    rx: 2,
    fill: "#10211A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 154.134,
    y: 51.3392,
    width: 1.14087,
    height: 90.7778,
    rx: 0.570436,
    fill: "#10211A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9.12697,
    height: 85.5654,
    transform: "translate(6.96289 82.1426)",
    fill: "#2E1B1A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5264,
    y: 75.2977,
    width: 1.14087,
    height: 127.778,
    rx: 0.570436,
    fill: "#2E1B1A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.9202,
    y: 175.463,
    width: 9.13871,
    height: 99.9165,
    rx: 2,
    fill: "#2E1B1A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 91.3889,
    y: 160.592,
    width: 1.14087,
    height: 129.16,
    rx: 0.570436,
    fill: "#2E1B1A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 166.731,
    y: 112.711,
    width: 9.13871,
    height: 102.353,
    rx: 2,
    fill: "#2E1B1A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 171.249,
    y: 105.76,
    width: 1.14087,
    height: 124.896,
    rx: 0.570436,
    fill: "#2E1B1A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 22.949,
    y: 157.186,
    width: 9.13871,
    height: 39.6011,
    rx: 2,
    fill: "#2E1B1A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 27.499,
    y: 150.301,
    width: 1.14087,
    height: 54.223,
    rx: 0.570436,
    fill: "#2E1B1A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 102.76,
    y: 194.35,
    width: 9.13871,
    height: 45.0843,
    rx: 2,
    fill: "#2E1B1A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 107.359,
    y: 184.387,
    width: 1.14087,
    height: 67.6264,
    rx: 0.570436,
    fill: "#2E1B1A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 182.572,
    y: 207.753,
    width: 9.13871,
    height: 53.6137,
    rx: 2,
    fill: "#2E1B1A"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 187.219,
    y: 197.053,
    width: 1.14087,
    height: 77.3744,
    rx: 0.570436,
    fill: "#2E1B1A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7893,
    y: 106.618,
    width: 9.13871,
    height: 87.7316,
    rx: 2,
    fill: "#10211A"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 42.3301,
    y: 95.469,
    width: 1.14087,
    height: 116.369,
    rx: 0.570436,
    fill: "#10211A"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 119.21,
    y: 159.013,
    width: 9.13871,
    height: 31.6808,
    rx: 2,
    fill: "#2E1B1A"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 123.332,
    y: 147.879,
    width: 1.14087,
    height: 52.3952,
    rx: 0.570436,
    fill: "#2E1B1A"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 198.412,
    y: 155.358,
    width: 9.13871,
    height: 77.3744,
    rx: 2,
    fill: "#10211A"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 202.052,
    y: 148.314,
    width: 1.14087,
    height: 116.369,
    rx: 0.570436,
    fill: "#10211A"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6299,
    y: 125.505,
    width: 9.13871,
    height: 42.038,
    rx: 2,
    fill: "#10211A"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 58.302,
    y: 113.746,
    width: 1.14087,
    height: 67.0172,
    rx: 0.570436,
    fill: "#10211A"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 134.441,
    y: 107.837,
    width: 9.13871,
    height: 59.7062,
    rx: 2,
    fill: "#10211A"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 138.163,
    y: 102.609,
    width: 1.14087,
    height: 76.7651,
    rx: 0.570436,
    fill: "#10211A"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 214.862,
    y: 132.207,
    width: 9.13871,
    height: 71.8911,
    rx: 2,
    fill: "#10211A"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 219.164,
    y: 123.944,
    width: 1.14087,
    height: 93.824,
    rx: 0.570436,
    fill: "#10211A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSwich);
export default __webpack_public_path__ + "static/media/mobile-swich.9b772de8d0fe73e826f4a33d7932a21e.svg";
export { ForwardRef as ReactComponent };